import Request from "./request";

const Message = "/reminds";
export default {
  async getMessage(query) {
    return Request.getReminds(Message, query);
  }
};
